<ngx-loading-bar color="#15b39b" height="3px" [fixed]="false" [includeSpinner]="false" [value]="(loader.progress$|async) || 0" ></ngx-loading-bar>
<form [formGroup]="FileSchedulesFormGroup"  #createfilescheduleform="ngForm"  (ngSubmit)="createClientFileSchedule(createfilescheduleform)" novalidate>
         <div class="divclientinfo"  flex="col" fxFlex.gt-sm="100" fxFlex="100">
          <Teranet-ClientTitle [ClientTitle]="'File Schedules'" [IconName]="'calendar-alt'"></Teranet-ClientTitle>
          <div *ngIf="Isshow">
            <Teranet-Clientfileschedule  [ClientId]="ClientId" [filescheduleform]="newclientfileschedule()"></Teranet-Clientfileschedule>
         <div class="savebtn">
        <button mat-button type="submit" *ngIf="!this.Readonly" >
         <div class="btnicon"><fa-icon icon="save"  id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon></div>
         <div class="btntext" matStepperNext>Save</div>
        </button>
              </div>
            </div>
             </div>
  </form>

